import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';

export const SignInButton = () => {
  const { signInWithGoogle } = useAuth();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    try {
      await signInWithGoogle();
      showNotification('Signed in successfully!', 'success');
    } catch (error) {
      showNotification('Failed to sign in. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={loading ? <CircularProgress size={16} sx={{ color: 'white' }} /> : <GoogleIcon />}
      onClick={handleSignIn}
      disabled={loading}
      sx={{
        color: 'white',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        '&:hover': {
          borderColor: 'white',
          bgcolor: 'rgba(255, 255, 255, 0.1)'
        }
      }}
    >
      {loading ? 'Signing in...' : 'Sign In'}
    </Button>
  );
};

